import { render, staticRenderFns } from "./DashboardMain.html?vue&type=template&id=7b8e0504&lang=html&external"
import script from "./DashboardMain.vue?vue&type=script&lang=js"
export * from "./DashboardMain.vue?vue&type=script&lang=js"
import style0 from "./DashboardMain.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports